module.exports = __webpack_public_path__ + "img/voltaire.6f45753d.png";